const ACTION_PATH = 'app/tiposGases'

export const CALL_CRIAR_FONTE_ENERGIAS = `${ACTION_PATH}/CALL_CRIAR_FONTE_ENERGIAS`
export const CALL_EXCLUIR_FONTE_ENERGIAS = `${ACTION_PATH}/CALL_EXCLUIR_FONTE_ENERGIAS`
export const CALL_ATUALIZAR_FONTE_ENERGIAS = `${ACTION_PATH}/CALL_ATUALIZAR_FONTE_ENERGIAS`

export const callCriarFonteEnergias = (payload) => ({
  type: CALL_CRIAR_FONTE_ENERGIAS,
  payload,
})

export const callAtualizarFonteEnergias = (payload) => ({
  type: CALL_ATUALIZAR_FONTE_ENERGIAS,
  payload,
})

export const callExcluirFonteEnergias = ({ id }) => ({
  type: CALL_EXCLUIR_FONTE_ENERGIAS,
  payload: { id },
})
